// src/pages/LoginPage.jsx
import React from 'react';
import LoginForm from '../components/LoginForm';

const LoginPage = ({ onLogin }) => {
  return (
    <LoginForm onLoginSuccess={onLogin} />
  );
};

export default LoginPage;
